import {
  CountryWithStateModel,
  IAPICreateContactModel,
} from "@mindmemobile/mm-payment-modules";
import {
  IAPIEditPromoterRequest,
  IAPIJoinFundRaiserRequest,
  IAPIPromoterProgressModel,
  IFundPromoters,
  IPromoter,
} from "../interfaces";
import { autorun } from "mobx";
import {
  AuthService,
  CoreInputModelUtil,
  getNewErrors,
  InputErrorModel,
} from "@mindmemobile/mm-shared-global";

// export class PromoterModel {
//   id: string;
//   firstName?: string;
//   lastName?: string;
//   name: string;
//   email: string;
//   mobile: string;
//   contactId?: string;
//   totalRaised: number;
//   goal: number;
//   rank: number;
//   avatar: string;
//   fundraiserId: string;
//   pageUrl: string;
//   joinDate: Date;
//   lastActivity: Date;
//   status: "active" | "inactive";

//   constructor(data?: Partial<PromoterModel>) {
//     this.id = data?.id ?? "";
//     this.firstName = data?.firstName ?? "";
//     this.lastName = data?.lastName ?? "";
//     this.name = data?.name ?? "";
//     this.email = data?.email ?? "";
//     this.mobile = data?.mobile ?? "";
//     this.contactId = data?.contactId ?? "";
//     this.totalRaised = data?.totalRaised ?? 0;
//     this.goal = data?.goal ?? 0;
//     this.rank = data?.rank ?? 0;
//     this.avatar = data?.avatar ?? "";
//     this.fundraiserId = data?.fundraiserId ?? "";
//     this.pageUrl = data?.pageUrl ?? "";
//     this.joinDate = data?.joinDate ? new Date(data.joinDate) : new Date();
//     this.lastActivity = data?.lastActivity
//       ? new Date(data.lastActivity)
//       : new Date();
//     this.status = data?.status ?? "inactive";
//   }

//   static deserializeAPIModel(data: IPromoter): PromoterModel {
//     return new PromoterModel({
//       id: data.id,
//       firstName: data.firstName,
//       lastName: data.lastName,
//       name: data.name,
//       email: data.email,
//       mobile: data.mobile,
//       contactId: data.contactId,
//       totalRaised: data.totalRaised,
//       goal: data.goal,
//       rank: data.rank,
//       avatar: data.avatar,
//       fundraiserId: data.fundraiserId,
//       pageUrl: data.pageUrl,
//       joinDate: data.joinDate,
//       lastActivity: data.lastActivity,
//       status: data.status,
//     });
//   }

//   static deserializeFundAPIModel(data: IFundPromoters): PromoterModel {
//     return new PromoterModel({ contactId: data.contactId });
//   }
// }

export class PromoterProgressModel {
  displayName: string = "";
  firstName: string = "";
  lastName: string = "";
  imageURL: string = "";
  rank: number = 0;
  goalAmount: number = 0;
  totalRaisedAmount: number = 0;
  id: string = "";
  contactId: string = "";
  mindmeContactId?: string = "";
  totalDonations: number = 0;
  isActive: boolean = true;
  email: string;
  mobile: string;
  countryId: string;
  countryCode: string;
  fundraiserId: string;
  isNew?: boolean;
  constructor(data?: Partial<PromoterProgressModel>) {
    this.displayName = data?.displayName || "";
    this.firstName = data?.firstName || "";
    this.lastName = data?.lastName || "";
    this.imageURL = data?.imageURL || "";
    this.rank = data?.rank || 0;
    this.goalAmount = data?.goalAmount || 0;
    this.totalRaisedAmount = data?.totalRaisedAmount || 0;
    this.id = data?.id || "";
    this.contactId = data?.contactId || "";
    this.mindmeContactId = data?.mindmeContactId || "";
    this.totalDonations = data?.totalDonations || 0;
    this.isActive = data?.isActive !== undefined ? data.isActive : true;
    this.email = data?.email || "";
    this.mobile = data?.mobile || "";
    this.countryId = data?.countryId || "";
    this.countryCode = data?.countryCode || "";
    this.fundraiserId = data?.fundraiserId || "";
    this.isNew = data?.isNew || false;
  }

  static remainingAmount(goalAmount: number, totalRaisedAmount: number) {
    return Math.max(0, goalAmount - totalRaisedAmount);
  }

  static sortedPromoters(allPromoters: PromoterProgressModel[]) {
    const sortedPromoters = allPromoters
      .slice()
      .sort((a, b) => b.totalRaisedAmount - a.totalRaisedAmount);
    return sortedPromoters;
  }

  static deserializeAPIModel(
    data: IAPIPromoterProgressModel,
    fundraiserId: string
  ): PromoterProgressModel {
    return new PromoterProgressModel({
      id: data.id,
      displayName: data.displayName,
      firstName: data.firstName,
      lastName: data.lastName,
      imageURL: data.imageURL,
      rank: data.rank,
      goalAmount: data.goalAmount,
      totalRaisedAmount: data.totalRaisedAmount,
      contactId: data.id,
      mindmeContactId: data.mindMeContactId,
      totalDonations: data.totalDonations,
      isActive: data.isActive,
      email: data.email,
      mobile: data.mobile,
      countryId: data.countryId,
      countryCode: data.countryCode,
      fundraiserId: fundraiserId,
    });
  }

  static createAPIRequestModel(
    fundraiserId: string,
    data: PromoterProgressModel
  ): IAPIEditPromoterRequest {
    return {
      accountId: AuthService.authData.accountId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobilePhone: data.mobile
        ? {
            phoneNumber: data.mobile,
            countryId: data.countryId || "",
            countryCode: data.countryCode || "",
          }
        : undefined,
      goalAmount: data.goalAmount,
      isActive: data.isActive,
      contactId: data.contactId,
      fundRaiserId: fundraiserId,
    };
  }
}

export class CreatePromoterContactModel {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  countryId: string;
  countryCode: string;
  errors: InputErrorModel<CreatePromoterContactModel>[] = [];
  constructor(data?: Partial<CreatePromoterContactModel>) {
    this.firstName = data?.firstName || "";
    this.lastName = data?.lastName || "";
    this.email = data?.email || "";
    this.mobile = data?.mobile || "";
    this.countryId = data?.countryId || "";
    this.countryCode = data?.countryCode || "";
    this.errors =
      (data &&
        data.errors?.map((e) => {
          return new InputErrorModel<CreatePromoterContactModel>(e);
        })) ||
      [];
    autorun(() => {
      this.validate(true);
    });
  }

  hasError(field: keyof CreatePromoterContactModel): boolean {
    return this.errors.some((e) => e.field === field);
  }

  validate(isAutoRun = false): boolean {
    const newErrors: InputErrorModel<CreatePromoterContactModel>[] = [];
    if (this.firstName) {
      CoreInputModelUtil.validateTextField(
        this.firstName,
        "firstName",
        newErrors
      );
    }
    if (this.lastName) {
      CoreInputModelUtil.validateTextField(
        this.lastName,
        "lastName",
        newErrors
      );
    }
    if (this.mobile) {
      CoreInputModelUtil.validateTextField(
        this.countryId,
        "countryId",
        newErrors
      );
      CoreInputModelUtil.validatePhoneNumber("mobile", this.mobile, newErrors);
    }
    CoreInputModelUtil.validateEmail("email", this.email, newErrors);

    if (isAutoRun) {
      this.errors = getNewErrors(newErrors, this.errors);
    } else {
      this.errors = newErrors;
    }
    return this.errors.length === 0;
  }

  static createAPIRequest(
    data: CreatePromoterContactModel,
    fundraiserId: string
  ): IAPIJoinFundRaiserRequest {
    return {
      company: "",
      fundRaiserId: fundraiserId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobilePhone: data.mobile
        ? {
            countryCode: data.countryCode,
            countryId: data.countryId,
            phoneNumber: data.mobile,
          }
        : undefined,
      accountId: AuthService.authData.accountId,
    };
  }

  static createAPIRequest2(
    formData: CreatePromoterContactModel
  ): IAPICreateContactModel {
    return {
      accountId: AuthService.authData.accountId,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      mobilePhone: formData.mobile
        ? {
            phoneNumber: formData.mobile,
            countryId: formData.countryId || "",
            countryCode: formData.countryCode || "",
          }
        : undefined,
      isFromFundraiser: true,
    };
  }
}
export class UpdatePromoterContactModel {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  countryId: string;
  countryCode: string;
  isActive: boolean;
  goalAmount: string;
  errors: InputErrorModel<UpdatePromoterContactModel>[] = [];
  constructor(data?: Partial<UpdatePromoterContactModel>) {
    this.firstName = data?.firstName || "";
    this.lastName = data?.lastName || "";
    this.email = data?.email || "";
    this.mobile = data?.mobile || "";
    this.countryId = data?.countryId || "";
    this.countryCode = data?.countryCode || "";
    this.isActive = data?.isActive || false;
    this.goalAmount = data?.goalAmount || "";
    this.errors =
      (data &&
        data.errors?.map((e) => {
          return new InputErrorModel<UpdatePromoterContactModel>(e);
        })) ||
      [];
    autorun(() => {
      this.validate(true);
    });
  }

  hasError(field: keyof UpdatePromoterContactModel): boolean {
    return this.errors.some((e) => e.field === field);
  }

  validate(isAutoRun = false): boolean {
    const newErrors: InputErrorModel<UpdatePromoterContactModel>[] = [];
    if (this.firstName) {
      CoreInputModelUtil.validateTextField(
        this.firstName,
        "firstName",
        newErrors
      );
    }
    if (this.lastName) {
      CoreInputModelUtil.validateTextField(
        this.lastName,
        "lastName",
        newErrors
      );
    }
    if (this.mobile) {
      CoreInputModelUtil.validatePhoneNumber("mobile", this.mobile, newErrors);
      CoreInputModelUtil.validateTextField(
        this.countryId,
        "countryId",
        newErrors
      );
    }
    CoreInputModelUtil.validateEmail("email", this.email, newErrors);

    if (isAutoRun) {
      this.errors = getNewErrors(newErrors, this.errors);
    } else {
      this.errors = newErrors;
    }
    return this.errors.length === 0;
  }

  static createAPIRequestModel(
    fundraiserId: string,
    contactId: string,
    goalAsInteger: number,
    data: UpdatePromoterContactModel
  ): IAPIEditPromoterRequest {
    return {
      accountId: AuthService.authData.accountId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobilePhone: data.mobile
        ? {
            phoneNumber: data.mobile,
            countryId: data.countryId || "",
            countryCode: data.countryCode || "",
          }
        : undefined,
      goalAmount: goalAsInteger,
      isActive: data.isActive,
      contactId: contactId,
      fundRaiserId: fundraiserId,
    };
  }
}

export class PromoterWithRank {
  id: string;
  name: string;
  totalRaised: number;
  actualRank: number;
  currentRank?: number;

  constructor(data?: Partial<PromoterWithRank>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.totalRaised = data?.totalRaised || 0;
    this.actualRank = data?.actualRank || 0;
    this.currentRank = data?.currentRank || 0;
  }
}
